export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";